import { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../contexts/auth';
import { REASON_FOR_UPDATING_USER } from '../contexts/auth/reducer';

export function useLanguageChange() {
  const { i18n } = useTranslation();

  const { updateUserReason } = useContext(AuthContext);

  const [pending, setPending] = useState(false);

  const changeLng = useCallback(
    async (lng: string) => {
      setPending(true);

      try {
        await i18n.changeLanguage(lng);
        await updateUserReason(REASON_FOR_UPDATING_USER.VISIT);
      } finally {
        setPending(false);
      }
    },
    [i18n, updateUserReason]
  );

  return [changeLng, pending] as [typeof changeLng, boolean];
}
